import { render } from "./FormAddTeam.vue?vue&type=template&id=fa2bc744&scoped=true"
import script from "./FormAddTeam.vue?vue&type=script&lang=js"
export * from "./FormAddTeam.vue?vue&type=script&lang=js"

import "./FormAddTeam.vue?vue&type=style&index=0&id=fa2bc744&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa2bc744"]])

export default __exports__